import React, { useEffect } from "react";
import Layout from "../../../components/layout/Layout";
import Table from "react-bootstrap/Table";
import { Button } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";
const AgrementSwedish = `${blobURL}/AgrementSwedish.pdf`;
const EnglishAgrement = `${blobURL}/EnglishAgrement.pdf`;

const Agreements = () => {
  const { t } = useTranslation();

  const download_file = (fileURL, PdfName) => {
    // for non-IE
    if (!window.ActiveXObject) {
      let save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      let filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = PdfName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        const evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    }

    // for IE < 11
    else if (!window.ActiveXObject && document.execCommand) {
      let _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, PdfName || fileURL);
      _window.close();
    }
  };

  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 invoice-space2 agreement agree-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/agreements"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/avtal"
          />
        )}
      </Helmet>
      <div className="page-content">
        <div className="agreements Contracts">
          <div className="agreements-list">
            <h4 className="accident_ins font-weight-bold">
              {t("Contract with Invozio")}
            </h4>

            <p>
              <span>{t("agrself")}</span>
            </p>
          </div>
        </div>
        <div className="w-100 agreemwnt-table">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{t("Certificate no")}</th>
                <th>Pdf</th>
                <th>{t("Download")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "460px" }}>1</td>
                <td>
                  {language === LOCALES.EN_US
                    ? "Invozio Agreement"
                    : "Invozio anställningsavtal"}
                </td>
                <td>
                  <Button
                    className="theme_btn"
                    onClick={() => {
                      download_file(
                        language === LOCALES.EN_US ? EnglishAgrement : AgrementSwedish,
                        language === LOCALES.EN_US ? "Agreement" : "anställningsavtal"
                      );
                    }}
                  >
                    <FiDownload className="new_colr" size={20} />
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Layout>
  );
};

export default Agreements;
